import React, { FunctionComponent, useCallback } from "react";
import PreExistingIcon from "@/shared/media/images/pre-existing.svg";
import { Button } from "./Button";
import { useModal } from "@/shared/hooks/useModal";
import { PreExistingConditionsModal } from "./PreExistingConditionsModal";

const PreExistingConditionsBanner = () => {
    const modal = useModal();

    const handleOpenModal = useCallback(
        (ModalComponent: FunctionComponent<any>, modalProps?: any) => {
            modal.openModal(ModalComponent, modalProps || {});
        },
        [modal]
    );

    return (
        <>
            <div data-testid="pre-existing-banner" className="mx-auto flex flex-row items-stretch">
                <div className="flex items-center justify-center rounded-l-md bg-background-tertiary p-2">
                    <PreExistingIcon className="h-full max-h-[64px] w-auto" />
                </div>
                <div className="flex flex-col items-start justify-center rounded-r-md bg-background-secondary p-3 text-content-primary">
                    <p className="text-sm font-bold leading-5 sm:text-lg">Sign up before pre-existing conditions pile up!</p>
                    <Button onClick={() => handleOpenModal(PreExistingConditionsModal)} className="mt-1 text-xs leading-4 underline sm:text-base" variant="ghost" size="auto">
                        What are pre-existing conditions?
                    </Button>
                </div>
            </div>
            {modal.render}
        </>
    );
};

export default PreExistingConditionsBanner;
